import { render, staticRenderFns } from "./WorkDetail10.vue?vue&type=template&id=af5828ca&scoped=true&"
import script from "./WorkDetail10.vue?vue&type=script&lang=js&"
export * from "./WorkDetail10.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail10.vue?vue&type=style&index=0&id=af5828ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5828ca",
  null
  
)

export default component.exports